const MuiTableContainer = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: "1px solid",
      borderColor: theme.palette.divider,
      borderRadius: "4px",
      overflow: "hidden"
    })
  }
};
const MuiTable = {
  styleOverrides: {
    root: ({ theme }) => ({
      ".MuiTableHead-root": {
        backgroundColor: theme.palette.background.secondary
      },
      ".MuiTableBody-root": {
        backgroundColor: theme.palette.background.paper,
        ".MuiTableCell-sizeMedium": {
          height: "50px",
          paddingTop: "5px",
          paddingBottom: "5px"
        },
        ".MuiTableCell-sizeSmall": {
          height: "32px",
          paddingTop: "0px",
          paddingBottom: "0px"
        },
        ".MuiTableRow-hover": {
          "&:hover": {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    })
  }
};
export {
  MuiTable,
  MuiTableContainer
};
//# sourceMappingURL=MuiTable.js.map
